import { createAction } from "redux-actions";

export const setSource = createAction("SET_SOURCE");